/**
 * Extracts the remoteFileId (last path segment) from a storage URL.
 *
 * Album photos use   .../resize/{remoteFileId}?token=...
 * PhotoChecker evals use .../get/{remoteFileId}?token=...
 *
 * Stripping to just the UUID makes both sides match regardless of the path prefix.
 */
function normalizePhotoUrl(url: string): string {
  try {
    const {pathname} = new URL(url);
    const lastSegment = pathname.split('/').filter(Boolean).at(-1);
    return lastSegment ?? url;
  } catch {
    const path = url.split('?')[0];
    const lastSegment = path.split('/').filter(Boolean).at(-1);
    return lastSegment ?? url;
  }
}

/**
 * Builds a lookup map from remoteFileId to score.
 */
export function buildPhotoScoreMap(
  evals: Array<{url: string; score: number}>
): Record<string, number> {
  return evals.reduce<Record<string, number>>((acc, item) => {
    acc[normalizePhotoUrl(item.url)] = item.score;
    return acc;
  }, {});
}

/**
 * Looks up the score for an album image URL using the remoteFileId map.
 */
export function matchPhotoScore(
  imageUrl: string,
  scoreMap: Record<string, number>
): number | undefined {
  return scoreMap[normalizePhotoUrl(imageUrl)];
}
